import { ConfigDefaults, PostHogConfig } from 'posthog-js';
import { isRealProduction, LOCAL_STORAGE_KEY } from 'Douleutaras/constants/system';
import { keepOnly } from 'Douleutaras/utilities/helpers/objects.helper';
import { User } from 'Douleutaras/types';

export const filterUserProperties = (props: User) => {
  const propsToKeep = [
    'date_joined',
    'first_name',
    'gender',
    'email',
    'is_manager',
    'is_staff',
    'is_test_user',
    'last_name',
    'user_type'
  ];

  return keepOnly(props, propsToKeep as Array<keyof User>);
};

const handleLoaded = posthog => {
  const parsed = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.USER_CREDENTIALS));
  const user = parsed?.v?.user;

  const gaClientId = () => {
    const match = document.cookie.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.(\d+\.\d+)/);

    // tslint:disable-next-line:no-null-keyword
    return match ? match[1] : null;
  };

  const commonProperties = {
    domain: window.location.hostname,
    ga_client_id: gaClientId(),
    is_existing_user: Boolean(user)
  };

  posthog.register(commonProperties);

  // User identification and person properties are handled exclusively
  // by PostHogProvider.identify() via the useAB hook to avoid duplicate
  // "Set person properties" events per session.
  if (user && !isRealProduction) {
    // tslint:disable-next-line:no-console
    console.info('identify (deferred to useAB)', filterUserProperties(user));
  }
};

export const posthogConfig: { apiKey: string; options: Partial<PostHogConfig> } = {
  apiKey: isRealProduction ? process.env.POSTHOG_KEY_PUBLIC_PROD : process.env.POSTHOG_KEY_PUBLIC_DEV,
  options: {
    api_host: isRealProduction ? process.env.POSTHOG_HOST_PUBLIC_PROD : process.env.POSTHOG_HOST_PUBLIC_DEV,
    defaults: '2025-05-24' as ConfigDefaults,
    autocapture: false,
    // Disable $pageview capture
    capture_pageview: false,
    // Disable $pageleave capture
    capture_pageleave: false,
    loaded: handleLoaded
  }
};
